import { ICoordinates } from '@bg-shared/interfaces/ICoordinates';

export class Star {
    public x: number;

    public y: number;

    public sizeRatio: number;

    public opacity: number;

    public spikes: number;

    public radius: number;

    public width: number;

    constructor(position: ICoordinates, radius: number, width: number, sizeRatio: number) {
        this.x = position.x;
        this.y = position.y;
        this.sizeRatio = sizeRatio;
        this.opacity = 1;
        this.spikes = 5;
        this.radius = radius;
        this.width = width;
    }

    public draw(
        ctx: CanvasRenderingContext2D,
        cx: number,
        cy: number,
        radius: number,
        opacity: number,
    ): void {
        let rot = (Math.PI / 2) * 3;
        let x = cx;
        let y = cy;
        const step = Math.PI / this.spikes;

        ctx.beginPath();
        ctx.moveTo(cx, cy - radius);
        for (let i = 0; i < this.spikes; i++) {
            x = cx + Math.cos(rot) * radius;
            y = cy + Math.sin(rot) * radius;
            ctx.lineTo(x, y);
            rot += step;

            x = cx + Math.cos(rot) * (radius / 2);
            y = cy + Math.sin(rot) * (radius / 2);
            ctx.lineTo(x, y);
            rot += step;
        }
        ctx.lineTo(cx, cy - radius);
        ctx.closePath();
        ctx.lineWidth = this.width;
        ctx.fillStyle = `rgba(255, 255, 0, ${opacity})`;
        ctx.fill();
    }
}
